import cn from 'client/utils/cn';

import React, { Component, RefObject } from 'react';

import { Direction } from '@yandex-lego/components/Popup/desktop';
import CopyButton from 'client/components/copy-button';
import Popup from 'client/components/lego/popup';

import './index.css';

const b = cn('hint-popup');

interface Props {
    visible: boolean;
    anchor: RefObject<HTMLElement>;
    directions?: Direction[];
    mixClassName: string | string[];
    content?: string;
    showCopyButton?: boolean;
}

class HintPopup extends Component<Props> {
    private textRef = React.createRef<HTMLElement>();

    render() {
        const {
            mixClassName,
            children,
            content,
            showCopyButton,
            anchor,
            visible,
            directions
        } = this.props;

        if (!(children || content)) {
            return null;
        }

        const mix = Array.isArray(mixClassName) ? mixClassName : [mixClassName];

        return (
            <Popup
                visible={visible}
                target="anchor"
                anchor={anchor}
                directions={directions}
                view="default"
                className={b('', mix)}
                >
                <div className={b('content')}>
                    {content ?
                        <span ref={this.textRef} dangerouslySetInnerHTML={{ __html: content }} /> :
                        children
                    }

                    {content && showCopyButton && (
                        <div className={b('copy-button')}>
                            <CopyButton textRef={this.textRef} />
                        </div>
                    )}
                </div>
            </Popup>
        );
    }
}

export default HintPopup;
